import { ProductTypeParameter } from '@products/services/graphql-fund-data.service';
import { ProductDTO } from '@products/types';
import { Chip, DropdownItem } from '@frk/eds-components';
import { FilterType, OptionWithCount } from '@types';

export interface Records {
  showed: number;
  all: number;
}

export interface SubscriptionsParams {
  apiUrl: string;
  id: string;
  sectionType: string;
  frequency: boolean;
  scale?: string;
}

export interface GroupItems {
  id?: string;
  label?: string;
}

export interface GridHeader {
  id: string;
  name: string;
  type: string;
}

export interface GridRowData {
  HAS_SUBSCRIPTION?: boolean;
  ID: string;
  PRODUCT_ID: string;
  ASSET_CLASS: string;
  NAME: string;
  FACTSHEET?: boolean;
  PROSPECTUS?: boolean;
  COMMENTARY?: boolean;
  ATTRIBUTION?: boolean;
  PERFORMANCE?: boolean;
  ANNUAL_REPORT?: boolean;
  SEMIANNUAL_REPORT?: boolean;
  SUMMARY_PROSPECTUS?: boolean;
  PORTFOLIO_HOLDINGS?: boolean;
  PRODUCT_PROFILE?: boolean;
  STATEMENT?: boolean;
  isChecked?: boolean;
}

export interface ProductTypesData {
  region: string;
  investorType: string;
  productTypes: ProductType[];
}

export interface ProductType {
  typeId: string | ProductTypeParameter;
  typeLabel: string;
  typeOrder: string;
  documentTypes: DocumentType[];
}

export interface DocumentType {
  documentId: string;
  documentLabel: string;
  documentTypeId: string;
}

export interface SubscriptionProductsData {
  region: string;
  investorType: string;
  products: SubscriptionProductDTO[];
}

export interface SubscriptionProductDTO {
  productAssetClass: string;
  productLabel: string;
  productOneTis: string;
  productType: string;
  productTypeId: string;
  productId: string;
}

export interface SubscribedProductDTO {
  productId: string;
  documentTypeId: string;
  active: boolean;
  autoSubscribed: boolean;
  subscriptionId?: string;
}

export interface GqlProductData {
  data: {
    PPSS: ProductDTO[];
  };
}

export interface HttpOptions {
  [name: string]: string;
}

export interface SelectAllDocs {
  dataParams: GridRowData;
}

export enum SwitchState {
  OFF = 'off',
  ON = 'on',
}

export interface ApiParameters {
  [name: string]: string;
}

export interface ProductsUserData {
  contactId: string;
  globalId: string;
  region: string;
  investorType: string;
  globalUnsubscribe: boolean;
  subscriptions: ProductSubscriptionsDTO[];
}

export interface ProductSubscriptionsDTO {
  productName: string;
  productOneTis: string;
  documentType: string;
  documentTypeId?: string;
  subscriptionId?: string;
  subscriptionName?: string;
  productId?: string;
  active?: boolean;
  autoSubscribed?: boolean;
  lastModifiedDate?: string;
}

export interface DocChip {
  id: string;
  selected: boolean;
  chips: Chip[];
}

export interface RowDataChange {
  changedDocuments: string[];
}

export type DropDownFilterType = FilterType & {
  preSelectedValues:
    | OptionWithCount
    | OptionWithCount[]
    | DropdownItem
    | DropdownItem[];
};
